import { bl_sfa_qualification_criteria_hdr_RowClass as bl_sfa_qualification_criteria_hdr_RowClass } from "../../dbschema/bl_sfa_qualification_criteria_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class SfaQualificationCriteriaContainerModel extends BaseContainerModel {
	bl_sfa_qualification_criteria_hdr: bl_sfa_qualification_criteria_hdr_RowClass =
		new bl_sfa_qualification_criteria_hdr_RowClass();
}
